import { NgModule } from '@angular/core';
import { environment } from '@environments/environment';
import { WidgetsUriConfig, WIDGETS_URI_CONFIG } from '@smooved/ui';

@NgModule({
    providers: [{ provide: WIDGETS_URI_CONFIG, useValue: new WidgetsUriConfig(environment.apiUri) }],
})
export class RealEstateAgentProvidersModule {}
